module.exports = __webpack_public_path__ + "static/img/productDesignManage.797f0c02.png";